import React, { memo, useEffect, useRef } from 'react'

//SCSS
import classes from './InfoPopup.module.scss'
import {ReactComponent as CloseSVG } from 'Assets/InfoPopup/Close.svg';


import TweenLite from "gsap/TweenLite";
import {Power1} from 'gsap';
function InfoPopup({onCloseCallback, active, modalData, infoPopupSelected, next, prev}){

    let containerRef = useRef()
    let innerContainer = useRef()
    let itemReferences = useRef([])
    let itemIconReferences = useRef([])
    let itemTitleReferences = useRef([])
    let itemDescrReferences = useRef([])
    let itemBTNReferences = useRef([])
    let btns = useRef([])

    let previousIndex = useRef(-1)

    useEffect(() => {
        // console.log(active)
        if(active){
            containerRef.current.classList.add(classes["info_popup--active"])
            TweenLite.fromTo(innerContainer.current, 0.5 ,{y:50, opacity:0}, {y:0, opacity:1, ease: Power1.easeIn})

           
        }else{
            
            containerRef.current.classList.remove(classes["info_popup--active"])
            TweenLite.to(innerContainer.current, 0.5 , {y:-500, opacity:0, ease: Power1.easeIn})
           
           
           
        }
    },[active])

    function onClosePress(){
        onCloseCallback()
      

    }

    function nextClick(){
      next();
    }
    function prevClick(){
      prev();
    }
    
    useEffect(() => {
        
        if(infoPopupSelected !== -1){
            let nextElementContainer = itemReferences.current[infoPopupSelected]
            let nextElementIcon = itemIconReferences.current[infoPopupSelected]
            let nextElementTitle = itemTitleReferences.current[infoPopupSelected]
            let nextElementDescr = itemDescrReferences.current[infoPopupSelected]
            let nextElementBTN = itemBTNReferences.current[infoPopupSelected]
            TweenLite.to(nextElementContainer,0.5, {opacity:1})
            TweenLite.fromTo(nextElementIcon, 0.5 , {y:60} , { y:0,ease: Power1.easeIn})
            TweenLite.fromTo(nextElementTitle, 0.5 , {y:40} , { y:20,ease: Power1.easeIn})
            TweenLite.fromTo(nextElementDescr, 0.5 , {y:40} , { y:20,ease: Power1.easeIn})
            TweenLite.fromTo(nextElementBTN, 0.5 , {y:5, opacity:1} , { y:0, opacity:1,ease: Power1.easeIn})
            nextElementContainer.style.zIndex = 1;
        }

        if(previousIndex.current !== -1){
            
            let previousElementContainer = itemReferences.current[previousIndex.current]
            let previousElementIcon = itemIconReferences.current[previousIndex.current]
            let previousElementTitle = itemTitleReferences.current[previousIndex.current]
            let previousElementDescr = itemDescrReferences.current[previousIndex.current]
            let previousElementBTN = itemBTNReferences.current[previousIndex.current]
            TweenLite.to(previousElementContainer,0.5,{opacity:0})
            TweenLite.fromTo(previousElementIcon, 0.5 , {y:0} , { y:-60,ease: Power1.easeIn})
            TweenLite.fromTo(previousElementTitle, 0.5 , {y:20} , { y:-20,ease: Power1.easeIn})
            TweenLite.fromTo(previousElementDescr, 0.5 , {y:20} , { y:-20,ease: Power1.easeIn})
            TweenLite.fromTo(previousElementBTN, 0.5 , {y:0, opacity:1} , { y:-20, opacity:0,ease: Power1.easeIn })
            previousElementContainer.style.zIndex = "auto";
        }
        
        previousIndex.current = infoPopupSelected

    }, [infoPopupSelected])

    let modalElement = Object.keys(modalData).map((el, index) => (
  
            <div key={el} ref={(ref) => { itemReferences.current[index] = ref }} className={`${classes.info_popup__wrapper}`} style={{opacity:0}}>
                <div className={`${classes.info_popup__top}`}>
                    <div ref={(ref) => { itemIconReferences.current[index] = ref }} >{modalData[el].icon}</div>
                    <h3 ref={(ref) => { itemTitleReferences.current[index] = ref }} className={`${classes.info_popup__title}`} dangerouslySetInnerHTML={{__html: modalData[el].title}}></h3>
                    <h4 ref={(ref) => { itemDescrReferences.current[index] = ref }} className={`${classes.info_popup__description}`}>{modalData[el].description}</h4>
                </div>
                <div ref={btns} className={`${classes.info_popup__btnContainer}`}>
                    <ul ref={(ref) => { itemBTNReferences.current[index] = ref }} className={`${classes.info_popup__btnList}`}>
                        <li className={`${classes.info_popup__btnListItem}`}>
                            <div className={`main-btn ${classes.info_popup__btnListLink}`} onClick={prevClick}>
                                back</div>
                        </li>
                        <li className={`${classes.info_popup__btnListItem}`}>
                            <div className={`main-btn ${classes.info_popup__btnListLink}`} onClick={nextClick}>
                                next</div>
                        </li>
                    </ul>
                </div>
            </div>
    
      
        )
    )

    return (
        <div ref={containerRef} className={`${classes.info_popup}`}>
            <div ref={innerContainer} className={`${classes.info_popup__container}`}>
                <div className={`${classes.info_popup__content}`}>
                    {modalElement}
                    <CloseSVG onClick={onClosePress}></CloseSVG>
                </div>
            </div>
        </div>
    )
}

export default memo( InfoPopup )